(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[639,180,46,75],[400,180,123,43],[709,45,294,43],[400,0,398,43],[848,135,145,43],[665,135,181,43],[800,0,188,43],[400,45,307,43],[400,135,263,43],[680,90,271,43],[400,90,278,43],[525,180,112,43],[0,0,398,348]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_28 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_27 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_26 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_25 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_24 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_23 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_22 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_21 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_20 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_19 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_18 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_17 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_16 = function() {
	this.initialize(img.CachedBmp_16);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3840,2160);


(lib.CachedBmp_15 = function() {
	this.initialize(img.CachedBmp_15);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3840,2160);


(lib.CachedBmp_14 = function() {
	this.initialize(img.CachedBmp_14);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3840,2160);


(lib.Image = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.size_1920x1080 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,500).lineTo(-960,-500).lineTo(960,-500).lineTo(960,500).closePath();
	this.shape.setTransform(960,500);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x1080, new cjs.Rectangle(0,0,1920,1000), null);


(lib.size_90x90 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-45,45).lineTo(-45,-45).lineTo(45,-45).lineTo(45,45).closePath();
	this.shape.setTransform(45,45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_90x90, new cjs.Rectangle(0,0,90,90), null);


(lib.vertical = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,1,1).moveTo(0,-8).lineTo(0,8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vertical, new cjs.Rectangle(-1,-9,2,18), null);


(lib.square = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// square
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#9881D1").beginStroke().moveTo(-4,4).lineTo(-4,-4).lineTo(4,-4).lineTo(4,4).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square, new cjs.Rectangle(-4,-4,8,8), null);


(lib.ball = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ball
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#9881D1").beginStroke().moveTo(-2.8,2.9).curveTo(-4,1.7,-4,0).curveTo(-4,-1.6,-2.8,-2.8).curveTo(-1.6,-4,0,-4).curveTo(1.6,-4,2.8,-2.8).curveTo(4,-1.6,4,0).curveTo(4,1.7,2.8,2.9).curveTo(1.6,4,0,4).curveTo(-1.6,4,-2.8,2.9).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ball, new cjs.Rectangle(-4,-4,8,8), null);


(lib.pseudo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(114,15,17,0.498)").beginStroke().moveTo(-67.4,30).lineTo(-67.4,-30).lineTo(67.4,-30).lineTo(67.4,30).closePath();
	this.shape.setTransform(67.4,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo, new cjs.Rectangle(0,0,134.8,60), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow_mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	mask.setTransform(0,11.325);

	// arrow
	this.instance = new lib.Image();
	this.instance.setTransform(-22.6,0,0.1508,0.1506);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrow_up, new cjs.Rectangle(-22.6,0,45.2,22.7), null);


(lib.solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#9881D1").setStrokeStyle(4,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.solid, new cjs.Rectangle(-2,-2,1924,4), null);


(lib.gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#B4B0BF","#9881D1"],[0,1],-960,0,960,0).beginStroke().moveTo(-960,2).lineTo(-960,-2).lineTo(960,-2).lineTo(960,2).closePath();
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.gradient, new cjs.Rectangle(0,-2,1920,4), null);


(lib._double = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#B4B0BF").setStrokeStyle(2,1,1).moveTo(400,0).lineTo(-400,0);
	this.shape.setTransform(700,60);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#9881D1").setStrokeStyle(2,1,1).moveTo(300,0).lineTo(-300,0);
	this.shape_1.setTransform(300,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib._double, new cjs.Rectangle(-1,-1,1102,62), null);


(lib.logo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.text = new cjs.Text("Before", "200px 'Montserrat Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 278;
	this.text.lineWidth = 676;
	this.text.parent = this;
	this.text.setTransform(233.35,2);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo, new cjs.Rectangle(-106.5,0,679.7,557.6), null);


(lib.texture_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-17.4,24.9).lineTo(-8.4,15.9).lineTo(-3.5,20.9).lineTo(-6.9,24.4).curveTo(-7.2,24.5,-7.2,24.9).curveTo(-7.2,24.9,-7.1,25).curveTo(-7.1,25.1,-7.1,25.1).curveTo(-7.1,25.2,-7,25.2).curveTo(-7,25.3,-6.9,25.3).lineTo(-0.5,31.8).curveTo(-0.3,32,0,32).curveTo(0.3,32,0.5,31.8).lineTo(7,25.3).curveTo(7,25.3,7,25.2).curveTo(7.1,25.2,7.1,25.1).curveTo(7.1,25.1,7.1,25).curveTo(7.1,24.9,7.1,24.9).curveTo(7.1,24.5,7,24.4).lineTo(3.5,20.9).lineTo(8.5,15.9).lineTo(17.4,24.9).lineTo(0,42.3).closePath().moveTo(-16.7,24.9).lineTo(0,41.6).lineTo(16.8,24.9).lineTo(8.5,16.5).lineTo(4.2,20.9).lineTo(7.3,24).curveTo(7.6,24.5,7.7,24.9).curveTo(7.6,25.2,7.3,25.7).lineTo(0.8,32.1).curveTo(0.5,32.5,0,32.5).curveTo(-0.5,32.5,-0.8,32.1).lineTo(-7.3,25.7).curveTo(-7.7,25.2,-7.6,24.9).curveTo(-7.7,24.5,-7.3,24).lineTo(-4.1,20.9).lineTo(-8.4,16.5).closePath().moveTo(26.5,24.5).lineTo(26.5,24.3).curveTo(26.5,23.2,26.2,22.1).curveTo(26,20.9,25.4,19.4).curveTo(24.8,17.9,24.1,17).curveTo(23.4,16,22.4,14.9).lineTo(15.9,8.4).lineTo(20.9,3.5).lineTo(25.3,7.9).curveTo(25.6,8.2,26,8).curveTo(26.5,7.8,26.5,7.4).lineTo(26.5,-7.4).curveTo(26.5,-7.8,26,-8.1).curveTo(25.6,-8.2,25.3,-7.9).lineTo(0,17.4).lineTo(-25.3,-7.9).curveTo(-25.7,-8.2,-26.1,-8.1).curveTo(-26.5,-7.8,-26.5,-7.4).lineTo(-26.5,7.4).curveTo(-26.5,7.8,-26.1,8).curveTo(-25.6,8.2,-25.3,7.9).lineTo(-20.9,3.5).lineTo(-15.9,8.4).lineTo(-22.4,14.9).curveTo(-23.4,16,-24.2,17).curveTo(-24.9,18.2,-25.4,19.4).curveTo(-25.9,20.6,-26.2,22).curveTo(-26.5,23.3,-26.4,24.3).lineTo(-26.4,24.5).lineTo(-38.5,24.5).lineTo(-38.5,22).lineTo(-38.3,22).curveTo(-36.4,21.8,-35.1,20.5).curveTo(-33.6,19.1,-33.6,17).lineTo(-33.6,17).lineTo(-33.5,16.8).lineTo(-33.5,-16.8).lineTo(-33.6,-17).curveTo(-33.6,-19.1,-35.1,-20.5).curveTo(-36.5,-21.9,-38.3,-22).lineTo(-38.5,-22.1).lineTo(-38.5,-24.5).lineTo(-26.4,-24.5).lineTo(-26.4,-24.3).curveTo(-26.5,-23.3,-26.2,-22.1).curveTo(-26,-21,-25.4,-19.5).curveTo(-25,-18.4,-24.2,-17.1).curveTo(-23.4,-15.9,-22.4,-14.9).lineTo(-0.5,7).curveTo(-0.3,7.2,0,7.2).curveTo(0.3,7.2,0.5,7).lineTo(22.4,-14.9).curveTo(23.4,-15.9,24.1,-17.1).curveTo(25,-18.4,25.4,-19.5).curveTo(26,-21,26.2,-22.1).curveTo(26.5,-23.3,26.5,-24.3).lineTo(26.5,-24.5).lineTo(38.5,-24.5).lineTo(38.5,-22.1).lineTo(38.3,-22).curveTo(36.6,-21.9,35.1,-20.5).curveTo(33.7,-19.1,33.6,-17).lineTo(33.5,-16.8).lineTo(33.5,16.8).lineTo(33.6,16.9).curveTo(33.7,19,35.1,20.5).curveTo(36.5,21.8,38.3,22).lineTo(38.5,22).lineTo(38.5,24.5).closePath().moveTo(16.6,8.4).lineTo(22.7,14.6).curveTo(23.7,15.6,24.5,16.8).curveTo(25.4,18,25.8,19.3).curveTo(26.4,20.7,26.7,22).curveTo(26.9,23.1,26.9,24).lineTo(38.1,24).lineTo(38.1,22.4).curveTo(36.2,22.2,34.8,20.8).curveTo(33.2,19.2,33.1,17).lineTo(33,16.8).lineTo(33,-16.8).lineTo(33.1,-17).curveTo(33.2,-19.3,34.8,-20.9).curveTo(36.2,-22.2,38.1,-22.5).lineTo(38.1,-24.1).lineTo(26.9,-24.1).curveTo(26.9,-23.1,26.7,-22).curveTo(26.4,-20.9,25.8,-19.3).curveTo(25.3,-17.9,24.5,-16.8).curveTo(23.7,-15.6,22.7,-14.6).lineTo(0.8,7.3).curveTo(0.4,7.6,0,7.6).curveTo(-0.5,7.6,-0.8,7.3).lineTo(-22.7,-14.6).curveTo(-23.7,-15.6,-24.5,-16.8).curveTo(-25.3,-17.9,-25.8,-19.3).curveTo(-26.3,-20.5,-26.6,-22).curveTo(-26.9,-23.1,-26.9,-24.1).lineTo(-38.1,-24.1).lineTo(-38.1,-22.5).curveTo(-36.2,-22.2,-34.8,-20.9).curveTo(-33.2,-19.3,-33.1,-17).lineTo(-33,-16.8).lineTo(-33,16.8).lineTo(-33.1,17.1).curveTo(-33.2,19.3,-34.8,20.8).curveTo(-36.2,22.2,-38.1,22.4).lineTo(-38.1,24).lineTo(-26.9,24).curveTo(-26.9,23.1,-26.6,21.9).curveTo(-26.3,20.4,-25.8,19.3).curveTo(-25.3,17.9,-24.5,16.8).curveTo(-23.7,15.6,-22.7,14.6).lineTo(-16.5,8.4).lineTo(-20.9,4.1).lineTo(-24.9,8.2).curveTo(-25.5,8.7,-26.3,8.4).curveTo(-26.9,8.2,-27,7.4).lineTo(-27,-7.4).curveTo(-26.9,-8.1,-26.3,-8.5).curveTo(-25.5,-8.7,-24.9,-8.2).lineTo(0,16.7).lineTo(25,-8.2).curveTo(25.5,-8.7,26.2,-8.5).curveTo(27,-8.1,26.9,-7.4).lineTo(26.9,7.4).curveTo(27,8.2,26.2,8.4).curveTo(25.5,8.7,25,8.2).lineTo(20.9,4.1).closePath().moveTo(0.5,-7).curveTo(0.3,-7.2,0,-7.2).curveTo(-0.3,-7.2,-0.5,-7).lineTo(-4,-3.5).lineTo(-9,-8.5).lineTo(-5.5,-12).curveTo(-5.4,-12,-5.4,-12.1).curveTo(-5.3,-12.1,-5.3,-12.2).curveTo(-5.3,-12.2,-5.3,-12.3).curveTo(-5.3,-12.4,-5.3,-12.4).curveTo(-5.3,-12.7,-5.5,-12.9).lineTo(-17.4,-24.9).lineTo(0,-42.3).lineTo(17.4,-24.9).lineTo(5.4,-12.9).curveTo(5.2,-12.7,5.2,-12.4).curveTo(5.2,-12.4,5.3,-12.3).curveTo(5.3,-12.2,5.3,-12.2).curveTo(5.3,-12.1,5.4,-12.1).curveTo(5.4,-12,5.4,-12).lineTo(8.9,-8.5).lineTo(4,-3.5).closePath().moveTo(0.8,-7.3).lineTo(4,-4.1).lineTo(8.3,-8.5).lineTo(5.1,-11.6).curveTo(4.8,-12.1,4.8,-12.4).curveTo(4.8,-12.8,5.1,-13.3).lineTo(16.8,-24.9).lineTo(0,-41.6).lineTo(-16.7,-24.9).lineTo(-5.1,-13.3).curveTo(-4.8,-12.8,-4.8,-12.4).curveTo(-4.8,-12.1,-5.1,-11.6).lineTo(-8.3,-8.5).lineTo(-4,-4.1).lineTo(-0.8,-7.3).curveTo(-0.5,-7.6,0,-7.6).curveTo(0.5,-7.6,0.8,-7.3).closePath().moveTo(-0.8,-17.6).lineTo(-7.3,-24.1).curveTo(-7.7,-24.4,-7.6,-24.9).curveTo(-7.7,-25.3,-7.3,-25.7).lineTo(-0.8,-32.2).curveTo(-0.5,-32.5,0,-32.5).curveTo(0.4,-32.5,0.8,-32.2).lineTo(7.3,-25.7).curveTo(7.6,-25.3,7.7,-24.9).curveTo(7.6,-24.4,7.3,-24.1).lineTo(0.8,-17.6).curveTo(0.5,-17.3,0,-17.3).curveTo(-0.5,-17.3,-0.8,-17.6).closePath().moveTo(-0.5,-31.9).lineTo(-6.9,-25.4).curveTo(-7.2,-25.2,-7.2,-24.9).curveTo(-7.2,-24.6,-6.9,-24.4).lineTo(-0.5,-17.9).curveTo(-0.3,-17.7,0,-17.7).curveTo(0.3,-17.7,0.5,-17.9).lineTo(7,-24.4).curveTo(7.1,-24.6,7.1,-24.9).curveTo(7.1,-25.2,7,-25.4).lineTo(0.5,-31.9).lineTo(0,-32.1).curveTo(-0.2,-32.1,-0.5,-31.9).closePath();
	mask.setTransform(38.5,42.275);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#EBC17D","#EBC17D","#E0B87C","#DFB77C","#CA9444","#C08329","#C9903C","#E1B16E","#EABE81","#EEDCC3"],[0,0.004,0.173,0.184,0.443,0.596,0.671,0.82,0.871,1],-37.5,0,37.5,0).beginStroke().moveTo(-38.5,42.3).lineTo(-38.5,-42.3).lineTo(38.5,-42.3).lineTo(38.5,42.3).closePath();
	this.shape.setTransform(38.5,42.275);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.texture_01, new cjs.Rectangle(0,0,77,84.6), null);


(lib.logo_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-79.3,17.8).lineTo(-73.1,11.6).lineTo(-69.8,14.9).lineTo(-72.2,17.3).curveTo(-72.3,17.4,-72.3,17.4).curveTo(-72.3,17.5,-72.3,17.5).curveTo(-72.4,17.6,-72.4,17.6).curveTo(-72.4,17.7,-72.4,17.8).curveTo(-72.4,17.8,-72.4,17.9).curveTo(-72.4,18,-72.3,18).curveTo(-72.3,18.1,-72.3,18.1).curveTo(-72.3,18.2,-72.2,18.2).lineTo(-67.6,22.8).curveTo(-67.4,23,-67.1,23).curveTo(-67,23,-67,23).curveTo(-66.9,23,-66.8,23).curveTo(-66.8,23,-66.7,22.9).curveTo(-66.7,22.9,-66.6,22.8).lineTo(-62,18.2).curveTo(-61.9,18.2,-61.9,18.1).curveTo(-61.9,18.1,-61.9,18).curveTo(-61.8,18,-61.8,17.9).curveTo(-61.8,17.8,-61.8,17.8).curveTo(-61.8,17.7,-61.8,17.6).curveTo(-61.8,17.6,-61.9,17.5).curveTo(-61.9,17.5,-61.9,17.4).curveTo(-61.9,17.4,-62,17.3).lineTo(-64.4,14.9).lineTo(-61.1,11.6).lineTo(-54.9,17.8).lineTo(-67.1,30).closePath().moveTo(49.4,20.8).curveTo(48.3,20.8,47.4,20.6).curveTo(46.6,20.2,46.1,19.8).curveTo(45.5,19.3,45.3,18.7).curveTo(45.1,18.2,45.1,17.3).curveTo(45.1,16.6,45.3,16).curveTo(45.6,15.4,46.1,14.9).curveTo(46.6,14.5,47.4,14.2).curveTo(48.3,13.9,49.4,13.9).lineTo(55.2,13.9).lineTo(55.2,15.7).lineTo(49.4,15.7).lineTo(48.3,15.8).curveTo(47.9,16,47.6,16.2).lineTo(47.3,16.7).lineTo(47.2,17.3).curveTo(47.2,18.2,47.7,18.5).curveTo(48.2,19,49.4,19).lineTo(54.7,19).lineTo(55.2,19).lineTo(55.2,20.8).closePath().moveTo(32.6,20.8).curveTo(31.4,20.8,30.6,20.6).curveTo(29.8,20.3,29.2,19.8).curveTo(28.7,19.3,28.5,18.7).curveTo(28.2,18.1,28.2,17.3).curveTo(28.2,16.7,28.5,16).curveTo(28.8,15.4,29.2,14.9).curveTo(29.7,14.5,30.6,14.2).curveTo(31.5,13.9,32.6,13.9).lineTo(35.5,13.9).curveTo(36.6,13.9,37.5,14.2).curveTo(38.4,14.5,38.9,14.9).curveTo(39.4,15.4,39.6,16).curveTo(39.9,16.7,39.9,17.3).curveTo(39.9,18.1,39.6,18.7).curveTo(39.4,19.3,38.9,19.8).curveTo(38.4,20.2,37.5,20.6).curveTo(36.7,20.8,35.5,20.8).closePath().moveTo(31.5,15.8).lineTo(30.8,16.2).lineTo(30.4,16.7).lineTo(30.4,17.3).curveTo(30.4,18.2,30.8,18.5).curveTo(31.3,19,32.6,19).lineTo(35.5,19).curveTo(36.8,19,37.3,18.5).curveTo(37.7,18.1,37.7,17.3).curveTo(37.7,16.6,37.3,16.2).curveTo(36.8,15.7,35.5,15.7).lineTo(32.6,15.7).lineTo(31.5,15.8).closePath().moveTo(15.7,20.8).curveTo(14.6,20.8,13.7,20.6).curveTo(12.9,20.2,12.4,19.8).curveTo(11.8,19.3,11.6,18.7).curveTo(11.4,18.1,11.4,17.3).curveTo(11.4,16.7,11.6,16).curveTo(11.9,15.4,12.4,14.9).curveTo(12.9,14.5,13.7,14.2).curveTo(14.7,13.9,15.7,13.9).lineTo(18.7,13.9).curveTo(19.8,13.9,20.7,14.2).curveTo(21.5,14.5,22,14.9).curveTo(22.5,15.4,22.8,16).curveTo(23,16.6,23,17.3).curveTo(23,18.2,22.8,18.7).curveTo(22.5,19.3,22,19.8).curveTo(21.5,20.3,20.7,20.6).curveTo(19.8,20.8,18.7,20.8).closePath().moveTo(14.6,15.8).curveTo(14.2,16,13.9,16.2).lineTo(13.6,16.7).lineTo(13.5,17.3).curveTo(13.5,18.2,14,18.5).curveTo(14.5,19,15.7,19).lineTo(18.7,19).curveTo(19.9,19,20.4,18.5).curveTo(20.9,18.2,20.9,17.3).curveTo(20.9,16.6,20.4,16.2).curveTo(19.9,15.7,18.7,15.7).lineTo(15.7,15.7).lineTo(14.6,15.8).closePath().moveTo(70.4,20.7).lineTo(69.6,19.7).lineTo(63.6,19.7).lineTo(62.9,20.7).lineTo(60.4,20.7).lineTo(65.5,14).lineTo(67.7,14).lineTo(72.8,20.7).closePath().moveTo(68.4,18.1).lineTo(66.6,15.7).lineTo(64.9,18.1).lineTo(68.4,18.1).closePath().moveTo(4.2,20.7).lineTo(4.2,16.8).lineTo(0.3,20.6).lineTo(-3.6,16.7).lineTo(-3.6,20.7).lineTo(-5.6,20.7).lineTo(-5.6,14).lineTo(-3.7,14).lineTo(0.3,17.9).lineTo(4.3,14).lineTo(6.2,14).lineTo(6.2,20.7).closePath().moveTo(79.3,18.7).lineTo(79.3,17.3).lineTo(94.5,17.3).lineTo(94.5,18.7).closePath().moveTo(-27.4,18.7).lineTo(-27.4,17.3).lineTo(-12.8,17.3).lineTo(-12.8,18.7).closePath().moveTo(-48,17.3).curveTo(-48,16.6,-48.2,15.7).curveTo(-48.4,14.6,-48.8,13.8).curveTo(-49.2,12.9,-49.7,12.1).curveTo(-50.3,11.2,-51,10.6).lineTo(-55.5,6).lineTo(-52.1,2.7).lineTo(-49.1,5.7).curveTo(-49.1,5.8,-49,5.8).curveTo(-49,5.8,-48.9,5.9).curveTo(-48.9,5.9,-48.8,5.9).curveTo(-48.7,5.9,-48.7,5.9).lineTo(-48.4,5.8).lineTo(-48.1,5.8).curveTo(-48.1,5.8,-48,5.8).curveTo(-48,5.8,-48,5.8).curveTo(-48,5.8,-47.9,5.8).curveTo(-47.9,5.8,-47.9,5.7).lineTo(-47.9,1.7).curveTo(-48.4,-3.7,-48.6,-3.8).lineTo(-48.7,-4.9).lineTo(-48.7,-6).curveTo(-48.7,-6,-48.8,-5.9).curveTo(-48.9,-5.9,-48.9,-5.9).curveTo(-49,-5.9,-49,-5.9).curveTo(-49.1,-5.8,-49.1,-5.8).lineTo(-67.1,12.2).lineTo(-85.1,-5.8).curveTo(-85.1,-5.8,-85.2,-5.9).curveTo(-85.2,-5.9,-85.3,-5.9).curveTo(-85.3,-5.9,-85.4,-5.9).curveTo(-85.5,-6,-85.5,-6).lineTo(-85.8,-6).curveTo(-86.2,-5.7,-86.2,-5.3).lineTo(-86.2,5.3).curveTo(-86.2,5.7,-85.8,5.8).lineTo(-85.5,5.9).curveTo(-85.5,5.9,-85.4,5.9).curveTo(-85.3,5.9,-85.3,5.9).curveTo(-85.2,5.8,-85.2,5.8).curveTo(-85.1,5.8,-85.1,5.7).lineTo(-82,2.7).lineTo(-78.7,6).lineTo(-83.2,10.6).curveTo(-83.9,11.2,-84.5,12.1).curveTo(-85,12.9,-85.4,13.8).lineTo(-86,15.7).lineTo(-86.2,17.3).lineTo(-94.5,17.3).lineTo(-94.5,15.9).curveTo(-93.1,15.8,-92.1,14.7).curveTo(-91,13.7,-90.9,12.2).lineTo(-90.9,-12.2).curveTo(-91,-13.7,-92.1,-14.8).curveTo(-93.1,-15.8,-94.5,-16).lineTo(-94.5,-17.4).lineTo(-86.2,-17.4).lineTo(-86,-15.8).lineTo(-85.4,-13.9).curveTo(-85,-13,-84.5,-12.1).curveTo(-84.1,-11.5,-83.2,-10.6).lineTo(-67.6,5.1).curveTo(-67.4,5.3,-67.1,5.3).curveTo(-67,5.3,-67,5.2).curveTo(-66.9,5.2,-66.8,5.2).curveTo(-66.8,5.2,-66.7,5.2).curveTo(-66.7,5.1,-66.6,5.1).lineTo(-51,-10.6).curveTo(-50.1,-11.5,-49.7,-12.1).curveTo(-49.2,-13,-48.8,-13.9).curveTo(-48.3,-14.9,-48.2,-15.8).lineTo(-48,-17.4).lineTo(-39.7,-17.4).lineTo(-39.7,-16).curveTo(-41.1,-15.8,-42.1,-14.8).curveTo(-43.2,-13.7,-43.3,-12.2).lineTo(-43.3,12.1).curveTo(-43.2,13.6,-42.1,14.7).curveTo(-41.1,15.8,-39.7,15.9).lineTo(-39.7,17.3).closePath().moveTo(15.7,2.8).curveTo(12.9,2.7,10.8,2.1).curveTo(8.7,1.5,7.4,0.3).curveTo(6.2,-0.9,5.6,-2.4).curveTo(5,-3.9,5,-5.7).curveTo(5,-7.5,5.6,-9).curveTo(6.2,-10.5,7.4,-11.7).curveTo(8.6,-12.9,10.8,-13.5).curveTo(12.9,-14.2,15.7,-14.2).lineTo(22.9,-14.2).curveTo(25.7,-14.2,27.8,-13.5).curveTo(30,-12.9,31.2,-11.7).curveTo(32.4,-10.5,33,-9).curveTo(33.6,-7.5,33.6,-5.7).curveTo(33.6,-3.9,33,-2.4).curveTo(32.4,-0.9,31.2,0.3).curveTo(29.9,1.5,27.8,2.1).curveTo(25.7,2.7,22.9,2.8).closePath().moveTo(13,-9.5).curveTo(11.8,-9.1,11.3,-8.6).curveTo(10.6,-7.9,10.4,-7.3).curveTo(10.2,-6.6,10.2,-5.7).curveTo(10.2,-3.8,11.4,-2.7).curveTo(12.6,-1.7,15.7,-1.7).lineTo(22.9,-1.7).curveTo(26,-1.7,27.2,-2.7).curveTo(28.3,-3.9,28.3,-5.7).curveTo(28.3,-7.6,27.2,-8.7).curveTo(26,-9.7,22.9,-9.7).lineTo(15.7,-9.7).curveTo(14.1,-9.7,13,-9.5).closePath().moveTo(88.6,2.6).lineTo(86.8,0.1).lineTo(72,0.1).lineTo(70.1,2.6).lineTo(64.1,2.6).lineTo(76.7,-14).lineTo(82,-14).lineTo(94.5,2.6).closePath().moveTo(83.8,-3.9).lineTo(79.4,-9.7).lineTo(75,-3.9).lineTo(83.8,-3.9).closePath().moveTo(57.8,2.6).lineTo(41.8,-8.2).lineTo(41.8,2.6).lineTo(36.9,2.6).lineTo(36.9,-14).lineTo(41.5,-14).lineTo(57.5,-3.2).lineTo(57.5,-14).lineTo(62.4,-14).lineTo(62.4,2.6).closePath().moveTo(-3.2,2.6).lineTo(-3.2,-7.1).lineTo(-12.8,2.2).lineTo(-22.4,-7.2).lineTo(-22.4,2.6).lineTo(-27.4,2.6).lineTo(-27.4,-14).lineTo(-22.7,-14).lineTo(-12.9,-4.5).lineTo(-3,-14).lineTo(1.7,-14).lineTo(1.7,2.6).closePath().moveTo(-66.6,-5.2).curveTo(-66.7,-5.2,-66.7,-5.2).curveTo(-66.8,-5.2,-66.8,-5.3).curveTo(-66.9,-5.3,-67,-5.3).curveTo(-67,-5.3,-67.1,-5.3).curveTo(-67.4,-5.3,-67.6,-5.2).lineTo(-69.9,-2.7).lineTo(-73.3,-6.1).lineTo(-70.9,-8.5).curveTo(-70.7,-8.6,-70.7,-8.9).curveTo(-70.7,-9.1,-70.9,-9.4).lineTo(-79.3,-17.8).lineTo(-67.1,-30).lineTo(-54.9,-17.8).lineTo(-63.3,-9.4).curveTo(-63.5,-9.2,-63.5,-8.9).curveTo(-63.5,-8.6,-63.3,-8.5).lineTo(-60.9,-6.1).lineTo(-64.2,-2.7).closePath().moveTo(-67.6,-22.9).lineTo(-72.2,-18.3).lineTo(-72.4,-17.8).curveTo(-72.4,-17.7,-72.4,-17.7).curveTo(-72.4,-17.6,-72.3,-17.6).curveTo(-72.3,-17.5,-72.3,-17.5).curveTo(-72.3,-17.4,-72.2,-17.3).lineTo(-67.6,-12.7).curveTo(-67.4,-12.6,-67.1,-12.5).curveTo(-67,-12.5,-67,-12.6).curveTo(-66.9,-12.6,-66.8,-12.6).curveTo(-66.8,-12.6,-66.7,-12.6).curveTo(-66.7,-12.7,-66.6,-12.7).lineTo(-62,-17.3).curveTo(-61.9,-17.4,-61.9,-17.5).curveTo(-61.9,-17.5,-61.9,-17.6).curveTo(-61.8,-17.6,-61.8,-17.7).curveTo(-61.8,-17.7,-61.8,-17.8).lineTo(-62,-18.3).lineTo(-66.6,-22.9).curveTo(-66.7,-22.9,-66.7,-23).curveTo(-66.8,-23,-66.8,-23).curveTo(-66.9,-23.1,-67,-23.1).curveTo(-67,-23.1,-67.1,-23.1).curveTo(-67.4,-23.1,-67.6,-22.9).closePath().moveTo(79.5,-17).curveTo(78.3,-17.5,77.7,-17.6).curveTo(76.7,-17.5,76,-16.8).lineTo(76,-19.7).curveTo(77.1,-20.8,78.4,-20.8).curveTo(79.1,-20.8,80.3,-20.4).curveTo(81.4,-19.8,81.9,-19.8).curveTo(82.9,-19.9,83.5,-20.6).lineTo(83.5,-17.8).curveTo(83.4,-17.4,82.9,-17).curveTo(82.2,-16.6,81.2,-16.6).curveTo(80.6,-16.6,79.5,-17).closePath();
	mask.setTransform(94.475,30);

	// Camada_3
	this.instance = new lib.Image();
	this.instance.setTransform(-5,-56.85,0.4999,0.4993);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_02, new cjs.Rectangle(0,0,189,60), null);


(lib.button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-64,-64,128,128);


(lib.texture_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// texture_mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-76.5,572.3).lineTo(-76.5,-572.2).lineTo(76.5,-572.2).lineTo(76.5,572.3).closePath();
	mask.setTransform(76.5341,572.3203);

	// texture
	this.instance = new lib.texture_01();
	this.instance.setTransform(114.6,1083.75);

	this.instance_1 = new lib.texture_01();
	this.instance_1.setTransform(38.05,1083.75);

	this.instance_2 = new lib.texture_01();
	this.instance_2.setTransform(-38.5,1083.75);

	this.instance_3 = new lib.texture_01();
	this.instance_3.setTransform(152.85,1017.55);

	this.instance_4 = new lib.texture_01();
	this.instance_4.setTransform(114.6,951.25);

	this.instance_5 = new lib.texture_01();
	this.instance_5.setTransform(152.85,885.05);

	this.instance_6 = new lib.texture_01();
	this.instance_6.setTransform(114.6,818.8);

	this.instance_7 = new lib.texture_01();
	this.instance_7.setTransform(152.85,752.55);

	this.instance_8 = new lib.texture_01();
	this.instance_8.setTransform(114.6,686.3);

	this.instance_9 = new lib.texture_01();
	this.instance_9.setTransform(152.85,620.1);

	this.instance_10 = new lib.texture_01();
	this.instance_10.setTransform(114.6,553.85);

	this.instance_11 = new lib.texture_01();
	this.instance_11.setTransform(152.85,487.6);

	this.instance_12 = new lib.texture_01();
	this.instance_12.setTransform(114.6,421.4);

	this.instance_13 = new lib.texture_01();
	this.instance_13.setTransform(152.85,355.15);

	this.instance_14 = new lib.texture_01();
	this.instance_14.setTransform(114.6,288.85);

	this.instance_15 = new lib.texture_01();
	this.instance_15.setTransform(152.85,222.65);

	this.instance_16 = new lib.texture_01();
	this.instance_16.setTransform(114.6,156.4);

	this.instance_17 = new lib.texture_01();
	this.instance_17.setTransform(152.85,90.15);

	this.instance_18 = new lib.texture_01();
	this.instance_18.setTransform(114.6,23.95);

	this.instance_19 = new lib.texture_01();
	this.instance_19.setTransform(152.85,-42.3);

	this.instance_20 = new lib.texture_01();
	this.instance_20.setTransform(76.3,1017.55);

	this.instance_21 = new lib.texture_01();
	this.instance_21.setTransform(38.05,951.25);

	this.instance_22 = new lib.texture_01();
	this.instance_22.setTransform(76.3,885.05);

	this.instance_23 = new lib.texture_01();
	this.instance_23.setTransform(38.05,818.8);

	this.instance_24 = new lib.texture_01();
	this.instance_24.setTransform(76.3,752.55);

	this.instance_25 = new lib.texture_01();
	this.instance_25.setTransform(38.05,686.3);

	this.instance_26 = new lib.texture_01();
	this.instance_26.setTransform(76.3,620.1);

	this.instance_27 = new lib.texture_01();
	this.instance_27.setTransform(38.05,553.85);

	this.instance_28 = new lib.texture_01();
	this.instance_28.setTransform(76.3,487.6);

	this.instance_29 = new lib.texture_01();
	this.instance_29.setTransform(38.05,421.4);

	this.instance_30 = new lib.texture_01();
	this.instance_30.setTransform(76.3,355.15);

	this.instance_31 = new lib.texture_01();
	this.instance_31.setTransform(38.05,288.85);

	this.instance_32 = new lib.texture_01();
	this.instance_32.setTransform(76.3,222.65);

	this.instance_33 = new lib.texture_01();
	this.instance_33.setTransform(38.05,156.4);

	this.instance_34 = new lib.texture_01();
	this.instance_34.setTransform(76.3,90.15);

	this.instance_35 = new lib.texture_01();
	this.instance_35.setTransform(38.05,23.95);

	this.instance_36 = new lib.texture_01();
	this.instance_36.setTransform(76.3,-42.3);

	this.instance_37 = new lib.texture_01();
	this.instance_37.setTransform(-0.25,1017.55);

	this.instance_38 = new lib.texture_01();
	this.instance_38.setTransform(-38.5,951.25);

	this.instance_39 = new lib.texture_01();
	this.instance_39.setTransform(-0.25,885.05);

	this.instance_40 = new lib.texture_01();
	this.instance_40.setTransform(-38.5,818.8);

	this.instance_41 = new lib.texture_01();
	this.instance_41.setTransform(-0.25,752.55);

	this.instance_42 = new lib.texture_01();
	this.instance_42.setTransform(-38.5,686.3);

	this.instance_43 = new lib.texture_01();
	this.instance_43.setTransform(-0.25,620.1);

	this.instance_44 = new lib.texture_01();
	this.instance_44.setTransform(-38.5,553.85);

	this.instance_45 = new lib.texture_01();
	this.instance_45.setTransform(-0.25,487.6);

	this.instance_46 = new lib.texture_01();
	this.instance_46.setTransform(-38.5,421.4);

	this.instance_47 = new lib.texture_01();
	this.instance_47.setTransform(-0.25,355.15);

	this.instance_48 = new lib.texture_01();
	this.instance_48.setTransform(-38.5,288.85);

	this.instance_49 = new lib.texture_01();
	this.instance_49.setTransform(-0.25,222.65);

	this.instance_50 = new lib.texture_01();
	this.instance_50.setTransform(-38.5,156.4);

	this.instance_51 = new lib.texture_01();
	this.instance_51.setTransform(-0.25,90.15);

	this.instance_52 = new lib.texture_01();
	this.instance_52.setTransform(-38.5,23.95);

	this.instance_53 = new lib.texture_01();
	this.instance_53.setTransform(-0.25,-42.3);

	var maskedShapeInstanceList = [this.instance,this.instance_1,this.instance_2,this.instance_3,this.instance_4,this.instance_5,this.instance_6,this.instance_7,this.instance_8,this.instance_9,this.instance_10,this.instance_11,this.instance_12,this.instance_13,this.instance_14,this.instance_15,this.instance_16,this.instance_17,this.instance_18,this.instance_19,this.instance_20,this.instance_21,this.instance_22,this.instance_23,this.instance_24,this.instance_25,this.instance_26,this.instance_27,this.instance_28,this.instance_29,this.instance_30,this.instance_31,this.instance_32,this.instance_33,this.instance_34,this.instance_35,this.instance_36,this.instance_37,this.instance_38,this.instance_39,this.instance_40,this.instance_41,this.instance_42,this.instance_43,this.instance_44,this.instance_45,this.instance_46,this.instance_47,this.instance_48,this.instance_49,this.instance_50,this.instance_51,this.instance_52,this.instance_53];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_53},{t:this.instance_52},{t:this.instance_51},{t:this.instance_50},{t:this.instance_49},{t:this.instance_48},{t:this.instance_47},{t:this.instance_46},{t:this.instance_45},{t:this.instance_44},{t:this.instance_43},{t:this.instance_42},{t:this.instance_41},{t:this.instance_40},{t:this.instance_39},{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.texture_02, new cjs.Rectangle(0,0.1,153.1,1144.5), null);


(lib.go_back = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.instance = new lib.button();
	this.instance.setTransform(20.25,40.25,0.3126,0.6252,0,0,0,0.8,0.4);
	new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// text
	this.instance_1 = new lib.CachedBmp_28();
	this.instance_1.setTransform(8.5,21.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#990000").beginStroke().moveTo(-20,40).lineTo(-20,-40).lineTo(20,-40).lineTo(20,40).closePath();
	this.shape.setTransform(20,40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.go_back, new cjs.Rectangle(0,0,40,80), null);


(lib.title = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.instance = new lib.vertical();
	this.instance.setTransform(1427.05,10.65);

	this.instance_1 = new lib.vertical();
	this.instance_1.setTransform(1332.85,10.65);

	this.instance_2 = new lib.vertical();
	this.instance_2.setTransform(1104.45,10.65);

	this.instance_3 = new lib.vertical();
	this.instance_3.setTransform(951.25,10.65);

	this.instance_4 = new lib.vertical();
	this.instance_4.setTransform(793.75,10.65);

	this.instance_5 = new lib.vertical();
	this.instance_5.setTransform(632.65,10.65);

	this.instance_6 = new lib.vertical();
	this.instance_6.setTransform(1216.95,10.65);

	this.instance_7 = new lib.vertical();
	this.instance_7.setTransform(411.65,10.65);

	this.instance_8 = new lib.vertical();
	this.instance_8.setTransform(236.15,10.65);

	this.instance_9 = new lib.vertical();
	this.instance_9.setTransform(67.15,10.65);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// square
	this.instance_10 = new lib.square();
	this.instance_10.setTransform(1355.2,13);
	this.instance_10.visible = false;

	this.instance_11 = new lib.square();
	this.instance_11.setTransform(1071.6,13);
	this.instance_11.visible = false;

	this.instance_12 = new lib.square();
	this.instance_12.setTransform(885.1,13);
	this.instance_12.visible = false;

	this.instance_13 = new lib.square();
	this.instance_13.setTransform(720.5,13);
	this.instance_13.visible = false;

	this.instance_14 = new lib.square();
	this.instance_14.setTransform(1224.6,13);
	this.instance_14.visible = false;

	this.instance_15 = new lib.square();
	this.instance_15.setTransform(549.2,13);
	this.instance_15.visible = false;

	this.instance_16 = new lib.square();
	this.instance_16.setTransform(366.9,13);
	this.instance_16.visible = false;

	this.instance_17 = new lib.square();
	this.instance_17.setTransform(193.5,13);
	this.instance_17.visible = false;

	this.instance_18 = new lib.square();
	this.instance_18.setTransform(81.8,13);
	this.instance_18.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10}]}).wait(1));

	// ball
	this.instance_19 = new lib.ball();
	this.instance_19.setTransform(1417.4,13);
	this.instance_19.visible = false;

	this.instance_20 = new lib.ball();
	this.instance_20.setTransform(1242.8,13);
	this.instance_20.visible = false;

	this.instance_21 = new lib.ball();
	this.instance_21.setTransform(1116.4,13);
	this.instance_21.visible = false;

	this.instance_22 = new lib.ball();
	this.instance_22.setTransform(934.1,13);
	this.instance_22.visible = false;

	this.instance_23 = new lib.ball();
	this.instance_23.setTransform(773.7,13);
	this.instance_23.visible = false;

	this.instance_24 = new lib.ball();
	this.instance_24.setTransform(606.6,13);
	this.instance_24.visible = false;

	this.instance_25 = new lib.ball();
	this.instance_25.setTransform(428.5,13);
	this.instance_25.visible = false;

	this.instance_26 = new lib.ball();
	this.instance_26.setTransform(259.3,13);
	this.instance_26.visible = false;

	this.instance_27 = new lib.ball();
	this.instance_27.setTransform(79.7,13);
	this.instance_27.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19}]}).wait(1));

	// title
	this.instance_28 = new lib.CachedBmp_27();
	this.instance_28.setTransform(1438,0,0.5,0.5);

	this.instance_29 = new lib.CachedBmp_26();
	this.instance_29.setTransform(78.1,0,0.5,0.5);

	this.instance_30 = new lib.CachedBmp_25();
	this.instance_30.setTransform(422.6,0,0.5,0.5);

	this.instance_31 = new lib.CachedBmp_24();
	this.instance_31.setTransform(1343.8,0,0.5,0.5);

	this.instance_32 = new lib.CachedBmp_23();
	this.instance_32.setTransform(1115.4,0,0.5,0.5);

	this.instance_33 = new lib.CachedBmp_22();
	this.instance_33.setTransform(1227.9,0,0.5,0.5);

	this.instance_34 = new lib.CachedBmp_21();
	this.instance_34.setTransform(247.1,0,0.5,0.5);

	this.instance_35 = new lib.CachedBmp_20();
	this.instance_35.setTransform(962.2,0,0.5,0.5);

	this.instance_36 = new lib.CachedBmp_19();
	this.instance_36.setTransform(804.7,0,0.5,0.5);

	this.instance_37 = new lib.CachedBmp_18();
	this.instance_37.setTransform(643.6,0,0.5,0.5);

	this.instance_38 = new lib.CachedBmp_17();
	this.instance_38.setTransform(0,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.title, new cjs.Rectangle(0,0,1499.5,21.5), null);


(lib.effect_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:10,end:19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// effect
	this.instance = new lib.arrow_up();
	this.instance.setTransform(0,7);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({y:-30},4).to({y:-22.65},2).to({y:-30},2).wait(2).to({y:7},8).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.6,-30,60,89.4);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line_solid
	this.instance = new lib.solid();
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// line_gradient
	this.instance_1 = new lib.gradient();
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// line_double
	this.instance_2 = new lib._double();
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#720F11").beginStroke().moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	this.shape.setTransform(960,30,1,0.75);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(-2,-2,1924,63), null);


(lib.logo_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {none:1,small:2,medium:3,large:4};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#B4B0BF").beginStroke().moveTo(27.8,16.9).curveTo(26.6,16.9,25.2,16.5).curveTo(23.8,16,22.6,15.1).curveTo(21.5,14.2,20.6,12.6).curveTo(19.9,11.1,19.8,8.9).lineTo(19.8,-16.9).lineTo(25.6,-16.9).lineTo(25.6,8.9).curveTo(25.5,10,26.2,10.5).curveTo(26.9,11.2,27.8,11.2).lineTo(30.4,11.2).lineTo(30.4,16.9).closePath().moveTo(13.8,16.9).curveTo(12.6,16.9,11.2,16.5).curveTo(9.8,16,8.6,15.1).curveTo(7.3,14.2,6.6,12.6).curveTo(5.8,11.1,5.8,8.9).lineTo(5.8,-16.9).lineTo(11.4,-16.9).lineTo(11.4,8.9).curveTo(11.5,10,12.1,10.5).curveTo(12.8,11.2,13.8,11.2).lineTo(16.3,11.2).lineTo(16.3,16.9).closePath().moveTo(-4,16.9).lineTo(-14.8,-6.6).lineTo(-14.9,-6.7).lineTo(-14.9,-6.6).lineTo(-23.1,11.2).lineTo(-15.5,11.2).lineTo(-12.9,16.9).lineTo(-27.6,16.9).curveTo(-28.8,16.9,-29.6,16).curveTo(-30.4,15.3,-30.4,14).curveTo(-30.4,13.6,-30.2,13.2).lineTo(-22.4,-4.1).lineTo(-22.3,-4.2).lineTo(-22.2,-4.4).lineTo(-20.7,-7.7).lineTo(-16.9,-15.9).lineTo(-16.6,-16.3).curveTo(-16,-16.8,-15,-16.9).lineTo(-14.8,-16.9).curveTo(-13.8,-16.8,-13.2,-16.3).lineTo(-12.8,-15.7).lineTo(-9.1,-7.7).lineTo(-7.6,-4.4).lineTo(-7.5,-4.3).lineTo(-7.5,-4.1).lineTo(0.9,14).lineTo(1,14.2).lineTo(1.3,14.7).lineTo(1.5,15.3).lineTo(2.3,16.9).closePath();
	this.shape.setTransform(97.1163,37.3007,0.7275,0.7273);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#9881D1").beginStroke().moveTo(11.6,20.6).lineTo(11.6,-2.6).curveTo(11.6,-4.1,12,-5.2).curveTo(12.3,-6.4,13,-7.3).curveTo(13.6,-8.2,14.4,-8.8).curveTo(15.2,-9.4,16.2,-9.8).curveTo(17,-10.2,18,-10.4).curveTo(18.8,-10.6,19.6,-10.6).lineTo(29.9,-10.6).curveTo(31.4,-10.6,32.6,-10.2).curveTo(33.7,-9.8,34.6,-9.2).curveTo(35.5,-8.6,36.2,-7.8).curveTo(36.8,-7,37.2,-6.1).curveTo(37.5,-5.2,37.8,-4.3).lineTo(37.9,-2.6).lineTo(37.9,5.2).curveTo(37.9,6.6,37.5,7.8).curveTo(37.2,9,36.5,9.9).curveTo(35.9,10.8,35.2,11.4).curveTo(34.3,12,33.5,12.4).curveTo(32.5,12.8,31.7,13).curveTo(30.7,13.2,29.9,13.2).lineTo(19.6,13.2).lineTo(19.6,7.5).lineTo(29.9,7.5).curveTo(31,7.5,31.7,6.9).curveTo(32.2,6.3,32.2,5.2).lineTo(32.2,-2.5).curveTo(32.2,-3.7,31.7,-4.3).curveTo(31,-4.9,29.9,-4.9).lineTo(19.6,-4.9).curveTo(18.5,-4.9,17.9,-4.3).curveTo(17.3,-3.7,17.3,-2.6).lineTo(17.3,20.6).closePath().moveTo(-11.3,13.2).curveTo(-12.5,13.2,-13.9,12.8).curveTo(-15.2,12.3,-16.4,11.4).curveTo(-17.6,10.5,-18.4,9).curveTo(-19.2,7.5,-19.2,5.3).curveTo(-19.2,4.1,-18.7,2.7).curveTo(-18.4,1.4,-17.4,0.2).curveTo(-16.5,-1,-15,-1.8).curveTo(-13.5,-2.6,-11.3,-2.6).lineTo(-1,-2.6).lineTo(-1,2.9).lineTo(-11.3,2.9).curveTo(-12.5,2.9,-13.1,3.6).curveTo(-13.8,4.3,-13.8,5.4).curveTo(-13.8,6.5,-13,7.1).curveTo(-12.3,7.7,-11.3,7.7).lineTo(-1,7.7).curveTo(0.2,7.7,0.8,7).curveTo(1.4,6.3,1.4,5.3).lineTo(1.4,-2.7).curveTo(1.4,-3.8,0.7,-4.5).curveTo(0.1,-5.2,-1,-5.2).lineTo(-13.5,-5.2).lineTo(-13.5,-10.6).lineTo(-1,-10.6).curveTo(0.1,-10.6,1.5,-10.2).curveTo(2.9,-9.7,4.1,-8.8).curveTo(5.3,-7.9,6,-6.4).curveTo(6.9,-4.9,6.8,-2.7).lineTo(6.8,5.3).curveTo(6.8,6.5,6.5,7.9).curveTo(6,9.2,5.1,10.4).curveTo(4.2,11.6,2.7,12.4).curveTo(1.1,13.2,-1,13.2).closePath().moveTo(-27.2,13.2).curveTo(-28.4,13.2,-29.8,12.8).curveTo(-31.2,12.3,-32.4,11.4).curveTo(-33.6,10.4,-34.4,8.9).curveTo(-35.2,7.4,-35.2,5.2).lineTo(-35.2,-5.2).lineTo(-37.9,-5.2).lineTo(-37.9,-10.6).lineTo(-35.2,-10.6).lineTo(-35.2,-20.6).lineTo(-29.5,-20.6).lineTo(-29.5,-10.6).lineTo(-17.5,-10.6).lineTo(-17.5,-5.2).lineTo(-29.5,-5.2).lineTo(-29.5,5.2).curveTo(-29.5,6.2,-28.8,6.8).curveTo(-28.2,7.5,-27.2,7.5).lineTo(-24.7,7.5).lineTo(-24.7,13.2).closePath();
	this.shape_1.setTransform(147.4235,40.0098,0.7275,0.7273);

	this.instance = new lib.logo_02();
	this.instance.setTransform(31.95,2,0.9333,0.9333,0,0,0,0.1,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_1,p:{scaleX:0.7275,scaleY:0.7273,x:147.4235,y:40.0098}},{t:this.shape,p:{scaleX:0.7275,scaleY:0.7273,x:97.1163,y:37.3007}}]},2).to({state:[{t:this.shape_1,p:{scaleX:0.9698,scaleY:0.9697,x:154.8939,y:39.9801}},{t:this.shape,p:{scaleX:0.9698,scaleY:0.9697,x:87.832,y:36.368}}]},1).to({state:[{t:this.instance}]},1).wait(1));

	// size
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-120,40).lineTo(-120,-40).lineTo(120,-40).lineTo(120,40).closePath();
	this.shape_2.setTransform(120,40);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-51,240,162.1);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1,frame02:2,frame03:3,frame04:4,frame05:5,frame06:6,frame07:7,frame08:8,frame09:9,frame10:10,frame11:11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(12));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#DDC8AD").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape.setTransform(960,540);

	this.instance = new lib.texture_02();
	this.instance.setTransform(1775.65,0,0.9433,0.9435);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape_1.setTransform(960,540);

	this.instance_1 = new lib.CachedBmp_14();
	this.instance_1.setTransform(0,0,0.5,0.5);

	this.instance_2 = new lib.CachedBmp_15();
	this.instance_2.setTransform(0,0,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_16();
	this.instance_3.setTransform(0,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},2).to({state:[{t:this.shape_1},{t:this.instance}]},1).to({state:[{t:this.shape_1},{t:this.instance}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_1}]},1).wait(1));

	// size
	this.instance_4 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(12));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-39.9,1992.5,1142.2);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"start":1,"complete":10,"end":19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectStart(library_name, 'before');
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectComplete(library_name, 'before');
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectEnd(library_name, 'before');
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// logo
	this.instance = new lib.logo();
	this.instance.setTransform(726.65,360.1);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({alpha:1},8).wait(2).to({alpha:0},8).wait(1));

	// button
	this.btn_start = new lib.button();
	this.btn_start.name = "btn_start";
	this.btn_start.setTransform(952.25,795.4);
	this.btn_start._off = true;
	new cjs.ButtonHelper(this.btn_start, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_start).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#00FF00").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape.setTransform(952.25,795.4);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// size
	this.instance_1 = new lib.size_1920x1080();
	this.instance_1.setTransform(960,540,1,1,0,0,0,960,540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1000);


(lib.marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2,"frame03":3,"frame04":4,"frame05":5,"frame06":6,"frame07":7,"frame08":8,"frame09":9,"frame10":10,"frame11":11,frame12:12};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(13));

	// arrow_up
	this.occ_animate = new lib.effect_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(38.1,0);
	this.occ_animate._off = true;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(2).to({_off:false},0).wait(1).to({x:161.65},0).wait(1).to({x:333.9},0).wait(1).to({x:532.15},0).wait(1).to({x:723.2},0).wait(1).to({x:882.5},0).wait(1).to({x:1037.85},0).wait(1).to({x:1170.7},0).wait(1).to({x:1284.9},0).wait(1).to({x:1389.95},0).wait(1).to({x:1478.75},0).wait(1));

	// size
	this.instance = new lib.size_90x90();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(13));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1501.4,90);


(lib.content_frame_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		const gotoPage = (event, {url}) => {
		    /**
		     * Go back page for portal.
		     */
		    window.open(url, '_self');
		}
		
		this._handleGoBack && this.btn_go_back.off('mousedown', this._handleGoBack);
		this._handleGoBack = this.btn_go_back.on('mousedown', gotoPage, false, false, {url: 'https://dialogo.interativo.app.br'});
		
		// const gotoPage = () => {
		//     /**
		//      * Close page with extension plugin chrome.
		//      */
		// 	//chrome.runtime.sendMessage('maglcmgfenlbeehaeohfbkncflcafmko', {action: 'closeBrowser'});
		//     /**
		//      * Close page with window browser.
		//      */
		// 	window.close();
		// }
		//
		// this._handleGoBack && this.btn_go_back.off('mousedown', this._handleGoBack);
		// this._handleGoBack = this.btn_go_back.on('mousedown', gotoPage);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// go_back
	this.btn_go_back = new lib.go_back();
	this.btn_go_back.name = "btn_go_back";
	this.btn_go_back.setTransform(1879.8,1000);

	this.timeline.addTween(cjs.Tween.get(this.btn_go_back).wait(1));

	// button
	this.btn_page12 = new lib.button();
	this.btn_page12.name = "btn_page12";
	this.btn_page12.setTransform(1782.4,1039.05,0.6366,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page12, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page11 = new lib.button();
	this.btn_page11.name = "btn_page11";
	this.btn_page11.setTransform(1693.55,1039.05,0.721,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page11, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page10 = new lib.button();
	this.btn_page10.name = "btn_page10";
	this.btn_page10.setTransform(1588.6,1039.05,0.8905,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page10, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page09 = new lib.button();
	this.btn_page09.name = "btn_page09";
	this.btn_page09.setTransform(1474.4,1039.05,0.864,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page09, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page08 = new lib.button();
	this.btn_page08.name = "btn_page08";
	this.btn_page08.setTransform(1341.7,1039.05,1.1819,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page08, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page07 = new lib.button();
	this.btn_page07.name = "btn_page07";
	this.btn_page07.setTransform(1186.25,1039.05,1.2155,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page07, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page06 = new lib.button();
	this.btn_page06.name = "btn_page06";
	this.btn_page06.setTransform(1026.95,1039.05,1.2436,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page06, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page05 = new lib.button();
	this.btn_page05.name = "btn_page05";
	this.btn_page05.setTransform(835.9,1039.05,1.7116,0.4688,0,0,0,0.3,0.1);
	new cjs.ButtonHelper(this.btn_page05, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page04 = new lib.button();
	this.btn_page04.name = "btn_page04";
	this.btn_page04.setTransform(637.4,1039.05,1.3562,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page04, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page03 = new lib.button();
	this.btn_page03.name = "btn_page03";
	this.btn_page03.setTransform(465.15,1039.05,1.3054,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page03, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page02 = new lib.button();
	this.btn_page02.name = "btn_page02";
	this.btn_page02.setTransform(341.4,1039.05,0.5953,0.4688,0,0,0,0.1,0.1);
	new cjs.ButtonHelper(this.btn_page02, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_page02},{t:this.btn_page03},{t:this.btn_page04},{t:this.btn_page05},{t:this.btn_page06},{t:this.btn_page07},{t:this.btn_page08},{t:this.btn_page09},{t:this.btn_page10},{t:this.btn_page11},{t:this.btn_page12}]}).wait(1));

	// button_logo
	this.btn_back = new lib.button();
	this.btn_back.name = "btn_back";
	this.btn_back.setTransform(185.4,1040.05,1.9531,0.625,0,0,0,0.2,0.1);
	this.btn_back.visible = false;
	new cjs.ButtonHelper(this.btn_back, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_back).wait(1));

	// marker
	this.occ_marker = new lib.marker();
	this.occ_marker.name = "occ_marker";
	this.occ_marker.setTransform(303.25,1073);

	this.timeline.addTween(cjs.Tween.get(this.occ_marker).wait(1));

	// marker_slider
	this.occ_marker_slider = new lib.arrow_up();
	this.occ_marker_slider.name = "occ_marker_slider";
	this.occ_marker_slider.setTransform(341.35,1057.35);
	this.occ_marker_slider.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_marker_slider).wait(1));

	// pseudo
	this.instance = new lib.pseudo();
	this.instance.setTransform(1381.3,1236.85);
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// title
	this.instance_1 = new lib.title();
	this.instance_1.setTransform(313.25,1021.55);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// logo
	this.occ_logo = new lib.logo_1();
	this.occ_logo.name = "occ_logo";
	this.occ_logo.setTransform(38.05,1000);
	this.occ_logo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo).wait(1));

	// background
	this.instance_2 = new lib.background();
	this.instance_2.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background_dynamic
	this.occ_dynamic = new lib.background_dynamic();
	this.occ_dynamic.name = "occ_dynamic";
	this.occ_dynamic.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_dynamic).wait(1));

	// size
	this.instance_3 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.content_frame_02, new cjs.Rectangle(-2,0,1924,1296.9), null);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.frame01Index(this, library_name);
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(2));

	// ContentFrame
	this.occ_frame_01 = new lib.content_frame_01();
	this.occ_frame_01.name = "occ_frame_01";

	this.occ_frame_02 = new lib.content_frame_02();
	this.occ_frame_02.name = "occ_frame_02";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.occ_frame_01}]},1).to({state:[{t:this.occ_frame_02}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1922,1296.9);
// library properties:
lib.properties = {
	id: '8D6FF2B23DC06844BB2994587C24925D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"./images/CachedBmp_16.png", id:"CachedBmp_16"},
		{src:"./images/CachedBmp_15.png", id:"CachedBmp_15"},
		{src:"./images/CachedBmp_14.png", id:"CachedBmp_14"},
		{src:"./images/index_atlas_1.png", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['8D6FF2B23DC06844BB2994587C24925D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = document.documentElement.clientWidth, ih = document.documentElement.clientHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
